// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-disable[data-v-0dfb13f2]{opacity:.5;pointer-events:none}", "",{"version":3,"sources":["webpack://./resources/js/tenant/Components/View/POS/CashRegisterCloseModal.vue"],"names":[],"mappings":"AACA,iCACI,UAAA,CACA,mBAAJ","sourcesContent":["\n.custom-disable\n    opacity: 0.5\n    pointer-events: none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
